import { createFileRoute } from '@tanstack/react-router'
import ChildPage from '@/pages/ChildPage'

export const Route = createFileRoute('/$leaid/_error-wrapper/records/child/$entityid')({
  component: ChildPage,
})